"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Divider = void 0;
Object.defineProperty(exports, "dividerSize", {
  enumerable: true,
  get: function get() {
    return _config["default"];
  }
});
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _config = _interopRequireDefault(require("./config"));
var _styledDivider = _interopRequireDefault(require("./styled-divider"));
var _excluded = ["color", "className", "dataTestId", "size", "tag"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef;
var propTypes = {
  color: _propTypes["default"].string,
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['xs', 's', 'm', 'l', 'xl']),
  tag: _propTypes["default"].string
};
var defaultProps = {
  color: undefined,
  className: undefined,
  dataTestId: undefined,
  size: undefined,
  tag: undefined
};
var Divider = exports.Divider = forwardRef(function (_ref, ref) {
  var color = _ref.color,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    size = _ref.size,
    tag = _ref.tag,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledDivider["default"], _extends({
    as: tag,
    color: color || 'var(--color-functional-divider)',
    className: className,
    "data-testid": dataTestId || 'fuse-divider',
    ref: ref,
    size: _config["default"][size] || _config["default"].xs
  }, rest));
});
Divider.propTypes = propTypes;
Divider.defaultProps = defaultProps;
var _default = exports["default"] = Divider;